var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "comment-container" }, [
    _c("div", { staticClass: "comment-header" }, [
      _c("div", { staticClass: "comment-left-wrapper" }, [
        _c("img", {
          staticClass: "comment-user-image",
          attrs: { src: _vm.imageUrl },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "comment-center-wrapper" }, [
        _c("span", { staticClass: "comment-name" }, [_vm._v(_vm._s(_vm.name))]),
        _vm._v(" "),
        _c("span", { staticClass: "comment-createdAt" }, [
          _vm._v(_vm._s(_vm._f("date")(_vm.comment.createdAt))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "comment-right-wrapper" },
        [
          _vm.showActions.includes("resolve") &&
          _vm.permission.canResolve &&
          !_vm.editMode
            ? _c(
                "button",
                {
                  staticClass: "comment-action-button",
                  attrs: { title: _vm.comment.resolved ? "Reopen" : "Resolve" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("resolveComment")
                    },
                  },
                },
                [
                  !_vm.comment.resolved
                    ? _c("i", { staticClass: "v-icon mdi mdi-check" })
                    : _c("i", { staticClass: "v-icon mdi mdi-refresh" }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showActions.includes("edit") &&
          _vm.comment.createdBy === _vm.currentUserId &&
          !_vm.editMode &&
          (!_vm.comment.resolved || _vm.comment.resolved === undefined)
            ? [
                _c(
                  "button",
                  {
                    staticClass: "comment-action-button",
                    attrs: { title: "Edit" },
                    on: {
                      click: function ($event) {
                        _vm.editMode = true
                      },
                    },
                  },
                  [_c("i", { staticClass: "v-icon mdi mdi-pencil" })]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showActions.includes("delete") &&
          _vm.comment.createdBy === _vm.currentUserId &&
          !_vm.editMode &&
          (!_vm.comment.resolved || _vm.comment.resolved === undefined)
            ? [
                _c(
                  "button",
                  {
                    staticClass: "comment-action-button",
                    attrs: { title: "Delete" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("deleteComment")
                      },
                    },
                  },
                  [_c("i", { staticClass: "v-icon mdi mdi-delete" })]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.editMode
      ? _c("div", { staticStyle: { width: "100%" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.content,
                expression: "content",
              },
            ],
            staticClass: "reply-input col",
            domProps: { value: _vm.content },
            on: {
              keydown: _vm.enterToEdit,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.content = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "comment-action-button",
              staticStyle: {
                position: "absolute",
                left: "auto",
                right: "3rem",
                bottom: "0.75rem",
              },
              attrs: { title: "Confirm change(s)" },
              on: {
                click: function ($event) {
                  return _vm.$emit("editComment", _vm.content)
                },
              },
            },
            [_c("i", { staticClass: "v-icon mdi mdi-check" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "comment-action-button",
              staticStyle: {
                position: "absolute",
                left: "auto",
                right: "1rem",
                bottom: "0.75rem",
              },
              attrs: { title: "Discard change(s)" },
              on: {
                click: function ($event) {
                  _vm.editMode = false
                },
              },
            },
            [_c("i", { staticClass: "v-icon mdi mdi-close" })]
          ),
        ])
      : _c("div", { staticClass: "comment-content" }, [
          _vm._v("\n    " + _vm._s(_vm.comment.content) + "\n  "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }